var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Change default country"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-14841 -531C-14841 -532.105 -14840.1 -533 -14839 -533H4709C4710.11 -533 4711 -532.105 4711 -531V1206C4711 1207.1 4710.11 1208 4709 1208H-14839C-14840.1 1208 -14841 1207.1 -14841 1206V-531Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-14839 -532H4709V-534H-14839V-532ZM4710 -531V1206H4712V-531H4710ZM4709 1207H-14839V1209H4709V1207ZM-14840 1206V-531H-14842V1206H-14840ZM-14839 1207C-14839.6 1207 -14840 1206.55 -14840 1206H-14842C-14842 1207.66 -14840.7 1209 -14839 1209V1207ZM4710 1206C4710 1206.55 4709.55 1207 4709 1207V1209C4710.66 1209 4712 1207.66 4712 1206H4710ZM4709 -532C4709.55 -532 4710 -531.552 4710 -531H4712C4712 -532.657 4710.66 -534 4709 -534V-532ZM-14839 -534C-14840.7 -534 -14842 -532.657 -14842 -531H-14840C-14840 -531.552 -14839.6 -532 -14839 -532V-534Z",
    fill: "white",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Select Country Dropdown",
    clipPath: "url(#clip0_1001_16839)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 768,
    transform: "translate(-952 -200)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147224013",
    filter: "url(#filter0_d_1001_16839)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 364,
    height: 704,
    transform: "translate(-36 -136)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147224050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147223317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147223320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2147223327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search Box"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -11.5,
    y: -11.5,
    width: 315,
    height: 47,
    rx: 5.5,
    stroke: "#EEEEF0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "my_location"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1001_16839",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1001_16839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "my_location_2",
    d: "M11.0008 22.95V20.95C8.91745 20.7167 7.12995 19.8542 5.63828 18.3625C4.14661 16.8709 3.28411 15.0834 3.05078 13H1.05078V11H3.05078C3.28411 8.91672 4.14661 7.12922 5.63828 5.63755C7.12995 4.14588 8.91745 3.28338 11.0008 3.05005V1.05005H13.0008V3.05005C15.0841 3.28338 16.8716 4.14588 18.3633 5.63755C19.8549 7.12922 20.7174 8.91672 20.9508 11H22.9508V13H20.9508C20.7174 15.0834 19.8549 16.8709 18.3633 18.3625C16.8716 19.8542 15.0841 20.7167 13.0008 20.95V22.95H11.0008ZM12.0008 19C13.9341 19 15.5841 18.3167 16.9508 16.95C18.3174 15.5834 19.0008 13.9334 19.0008 12C19.0008 10.0667 18.3174 8.41672 16.9508 7.05005C15.5841 5.68338 13.9341 5.00005 12.0008 5.00005C10.0674 5.00005 8.41745 5.68338 7.05078 7.05005C5.68411 8.41672 5.00078 10.0667 5.00078 12C5.00078 13.9334 5.68411 15.5834 7.05078 16.95C8.41745 18.3167 10.0674 19 12.0008 19ZM12.0008 16C10.9008 16 9.95912 15.6084 9.17578 14.825C8.39245 14.0417 8.00078 13.1 8.00078 12C8.00078 10.9 8.39245 9.95838 9.17578 9.17505C9.95912 8.39172 10.9008 8.00005 12.0008 8.00005C13.1008 8.00005 14.0424 8.39172 14.8258 9.17505C15.6091 9.95838 16.0008 10.9 16.0008 12C16.0008 13.1 15.6091 14.0417 14.8258 14.825C14.0424 15.6084 13.1008 16 12.0008 16ZM12.0008 14C12.5508 14 13.0216 13.8042 13.4133 13.4125C13.8049 13.0209 14.0008 12.55 14.0008 12C14.0008 11.45 13.8049 10.9792 13.4133 10.5875C13.0216 10.1959 12.5508 10 12.0008 10C11.4508 10 10.9799 10.1959 10.5883 10.5875C10.1966 10.9792 10.0008 11.45 10.0008 12C10.0008 12.55 10.1966 13.0209 10.5883 13.4125C10.9799 13.8042 11.4508 14 12.0008 14Z",
    fill: "#3F25AE"
  })))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1001_16839",
    x: -55,
    y: -151,
    width: 402,
    height: 742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1001_16839"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1001_16839",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1001_16839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 768,
    fill: "white",
    transform: "translate(-952 -200)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLocation);
export default __webpack_public_path__ + "static/media/my_location.5a991152e3fa07f60986f5a197b71a15.svg";
export { ForwardRef as ReactComponent };